import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        // my: null,
        cw: document.documentElement.clientWidth,
        ch: document.documentElement.clientHeight,
    },
    mutations: {
        SET_CW(state, cw) {
            state.cw = cw;
        },
        SET_CH(state, ch) {
            state.ch = ch;
        },
    },
    actions: {
    },
});
